export const calculateTotalPage = (totalData: number): number => {
  let totalPage = (totalData - (totalData % 10)) / 10;
  totalPage += totalData % 10 > 0 ? 1 : 0;
  return totalPage;
};
